export default {
  NEW: `#graphql
  mutation createChange($order: String!, $reasons: [String]!, $waitPackage: Boolean!, $conveyorPaidByCompany: Boolean!) {
    createChange(order: $order, reasons: $reasons, waitPackage: $waitPackage, conveyorPaidByCompany: $conveyorPaidByCompany)         
  }`,

  GET_ALL: `#graphql
  query getChanges($search: String, $searchBy: String, $search1: String, $searchBy1: String, $limit: Int, $page: Int, $sort: String, $order: String, $init: Date, $final: Date) {
    getChanges(search: $search, searchBy: $searchBy, search1: $search1, searchBy1: $searchBy1, limit: $limit, page: $page, sort: $sort, order: $order, init:  $init, final: $final)
    { 
      docs {
        change,
        order,
        isSale,
        status,
        quantitySale,
        dni,
        name,
        phones,
        email,
        address,
        community,
        location,
        department,
        remitData {
          name,
          location,
          phone,
          department,
          address,
          generatedBy,
          createdAt
        },
        remitDataGenerated,
        dataLocked,
        conveyor,
        conveyorCustomer,
        conveyorCost,
        tracking,
        conveyorPaidByCompany,
        isWholesaler,
        isDropshipping,
        userPayConveyor,
        cod,
        originalProducts {
          product,
          sizes,
          quantityCart,
          refundedQuantity,
          quantityBonus,
          quantityTransfer,
          images,
          priceUnit,
          priceThree,
          priceThreeCommunity,
          priceWholesaler,
          priceSale,
          priceSaleCommunity,
          folder,
          subfolder,
          article,
          person,
          colors,
          picked,
          checked,
          tiers,
          design,
          brand,
          keywords,
          pinned,
          isClearence
        },
        newProducts {
          product,
          sizes,
          quantityCart,
          refundedQuantity,
          quantityBonus,
          quantityTransfer,
          images,
          priceUnit,
          priceThree,
          priceThreeCommunity,
          priceWholesaler,
          priceSale,
          priceSaleCommunity,
          folder,
          subfolder,
          article,
          person,
          colors,
          picked,
          checked,
          tiers,
          design,
          brand,
          keywords,
          pinned,
          isClearance
        },
        deliveries {
          delivery,
          nameRecipient,
          phonesRecipient,
          addressRecipient,
          conveyor,
          tracking,
          createdBy,
          createdAt,
          deliveredBy,
          deliveredAt,
          inProgressAt,
          inProgressBy,
          declinedAt,
          declinedBy,
          deliveredAt,
          deliveredBy,
          status,
          type
        },
        createdAt,
        createdBy,
        declinedAt,
        declinedBy,
        approvedAt,
        approvedBy,
        packedAt,
        packedBy,
        paidAt,
        paidBy,
        sentAt,
        sentBy,
        collectedAt,
        collectedBy,
        collectedValue,
        payManual {
          state,
          methodPay,
          value,
          createdAt,
          createdBy
        },
        observations {
          observation,
          type,
          createdAt,
          createdBy
        },
        packReceived,
        packReceivedAt,
        packReceivedBy,
        reasons,
        waitPackage,
        brand,
        saleByUnit
      },
      totalDocs,
      limit,
      hasPrevPage,
      hasNextPage,
      page,
      totalPages,
      prevPage,
      nextPage,
      pagingCounter
    }            
  }`,

  GET_BY_CHANGE_ADMIN: `#graphql
  query getByChangeAdmin($change: String!) {
    getByChangeAdmin(change: $change) {
      status,
      quantitySale,
      order,
      isSale,
      isWholesaler,
      isDropshipping,
      name,
      change,
      brand,
      createdAt,
      phones,
      address,
      location,
      department,
      remitData {
        name,
        location,
        phone,
        department,
        address,
        generatedBy,
        createdAt
      },
      remitDataGenerated,
      dataLocked,
      methodPay,
      conveyor,
      cod,
      userPayConveyor,
      observations {
        observation,
        type
      },
      originalProducts {
        product,
        sizes,
        quantityCart,
        refundedQuantity,
        quantityBonus,
        quantityTransfer,
        images,
        priceUnit,
        priceThree,
        priceThreeCommunity,
        priceWholesaler,
        priceSale,
        priceSaleCommunity,
        folder,
        subfolder,
        article,
        person,
        colors,
        picked,
        checked,
        tiers,
        design,
        brand,
        keywords,
        pinned,
        isClearence
      },
      newProducts {
        product,
        sizes,
        quantityCart,
        refundedQuantity,
        quantityBonus,
        quantityTransfer,
        images,
        priceUnit,
        priceThree,
        priceThreeCommunity,
        priceWholesaler,
        priceSale,
        priceSaleCommunity,
        folder,
        subfolder,
        article,
        person,
        colors,
        picked,
        checked,
        tiers,
        design,
        brand,
        keywords,
        pinned,
        isClearance
      },
      deliveries {
        delivery,
        dniDeliveryMan,
        nameRecipient,
        phonesRecipient,
        addressRecipient,
        locationRecipient,
        departmentRecipient,
        tracking,
        conveyor,
        idRemission,
        cost,
        idWelivery,
        status,
        trackingCancelled,
        createdAt
      },
      payManual {
        state,
        methodPay,
        value,
        createdAt,
        createdBy
      }
    }
  }`,

  UPDATE: `#graphql
  mutation UpdateChange($change: String!, $changeUpdate: ChangeUpdateInput!) {
    updateChange(change:$change, changeUpdate: $changeUpdate)
    {
      change
    }
  }`,

  ADD_PRODUCT: `#graphql
  mutation addProductChange($change: String!, $product: String!, $size: String!, $quantity: Int!, $tier: String) {
    addProductChange(change: $change, product: $product, size: $size, quantity: $quantity, tier: $tier)        
  }`,

  SUBTRACT_PRODUCT: `#graphql
  mutation subtractProductChange($change: String!, $product: String!, $size: String!, $quantity: Int!, $tier: String) {
    subtractProductChange(change: $change, product: $product, size: $size, quantity: $quantity, tier: $tier)        
  }`,

  UPDATE_PRICE_PRODUCT: `#graphql
  mutation updatePriceProductChange($change: String!, $product: String!, $price: Int!) {
    updatePriceProductChange(change: $change, product: $product, price: $price)        
  }`,

  APPROVE: `#graphql
  mutation approveChange($change: String!, $sendNotifications: Boolean!) {
    approveChange(change: $change, sendNotifications: $sendNotifications)        
  }`,

  DISAPPROVE: `#graphql
  mutation disapproveChange($change: String!) {
    disapproveChange(change: $change)        
  }`,

  PAY: `#graphql
  mutation payChange($change: String!) {
    payChange(change: $change)        
  }`,

  DELETE_PAY: `#graphql
  mutation deletePayChange($change: String!) {
    deletePayChange(change: $change)        
  }`,

  ADD_PAY_MANUAL: `#graphql
  mutation addPayManualChange($change: String!, $value: Int!, $methodPay: String!) {
    addPayManualChange(change: $change, value: $value, methodPay: $methodPay)        
  }`,

  DECLINE_PAY_MANUAL: `#graphql
  mutation declinePayManualChange($change: String!, $payIndex: Int!) {
    declinePayManualChange(change: $change, payIndex: $payIndex)     
  }`,

  APPROVE_PAY_MANUAL: `#graphql
  mutation approvePayManualChange($change: String!, $payIndex: Int!) {
    approvePayManualChange(change: $change, payIndex: $payIndex)     
  }`,

  ADD_OBSERVATION: `#graphql
  mutation addObservationChange($change: String!, $observation: String!, $type: String!) {
    addObservationChange(change: $change, observation: $observation, type: $type)        
  }`,

  PICK_PRODUCT_CHANGE: `#graphql
  mutation pickProductChange($change: String!, $product: String!, $size: String!, $tier: String!) {
    pickProductChange(change: $change, product: $product, size: $size, tier: $tier)     
  }`,

  UNPICK_PRODUCT_CHANGE: `#graphql
  mutation unpickProductChange($change: String!, $product: String!, $size: String!, $tier: String!, $returnTier: String) {
    unpickProductChange(change: $change, product: $product, size: $size, tier: $tier, returnTier: $returnTier)     
  }`,

  CHECK_PRODUCT_CHANGE: `#graphql
  mutation checkProductChange($change: String!, $product: String!, $size: String!) {
    checkProductChange(change: $change, product: $product, size: $size)     
  }`,

  PACK: `#graphql
  mutation packChange($change: String!, $sendNotifications: Boolean!) {
    packChange(change: $change, sendNotifications: $sendNotifications)        
  }`,

  UNPACK: `#graphql
  mutation unpackChange($change: String!) {
    unpackChange(change: $change)        
  }`,

  SEND: `#graphql
  mutation sendChange($change: String!, $sendNotifications: Boolean!, $skipGuide: Boolean) {
    sendChange(change: $change, sendNotifications: $sendNotifications, skipGuide: $skipGuide)
  }`,

  BACK_SEND: `#graphql
  mutation backSendChange($change: String!) {
    backSendChange(change: $change)        
  }`,

  DECLINE: `#graphql
  mutation declineChange($change: String!, $sendNotifications: Boolean!) {
    declineChange(change: $change, sendNotifications: $sendNotifications)        
  }`,

  RECEIVE_PACKAGE: `#graphql
  mutation receivePackage($change: String!, $sendNotifications: Boolean!) {
    receivePackage(change: $change, sendNotifications: $sendNotifications)        
  }`,

  UNRECEIVE_PACKAGE: `#graphql
  mutation unreceivePackage($change: String!) {
    unreceivePackage(change: $change)        
  }`,

  NEW_DELIVERY: `#graphql
  mutation newDeliveryChange($change: String!, $type: String!) {
    newDeliveryChange(change: $change, type: $type)
  }`,

  UNLOCK_CHANGE_DATA: `#graphql
  mutation unlockChangeData($change: String!) {
    unlockChangeData(change: $change) {
      change
      dataLocked
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/change.js